import { ColumnDef } from '@tanstack/react-table';

import { SimpleTooltip } from '@eluve/components';
import { SortableColumnHeader, Text } from '@eluve/components';

export interface PromptTemplateColDefProps {
  promptTemplate: {
    id: string;
    name: string;
  } | null;
}

export const PromptTemplateColDef = <
  T extends PromptTemplateColDefProps,
>(): ColumnDef<T> => ({
  accessorKey: 'promptTemplate',
  accessorFn: (row) => row.promptTemplate?.name ?? '',
  header: ({ column }) => (
    <SortableColumnHeader column={column} label="Prompt template" />
  ),
  cell: ({ row }) => {
    const template = row.original.promptTemplate;
    if (!template) {
      return <Text color="disabled">No summary generated.</Text>;
    }

    return (
      <SimpleTooltip label={`id: ${template.id}`}>
        <div>
          <Text>{template.name}</Text>
        </div>
      </SimpleTooltip>
    );
  },
});
